export default "__VITE_ASSET__c3d47d40__"